import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import { getNewChartData, getDatasourceAndDates } from '../../../api';
import { isFullscreen } from '../utils/Utils';
import { xlsxCustomExport } from '../utils/chartConfig';

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);

const IMG_URL = process.env.IMG_FULL_URL;

class SafetyRisksChart extends Component { 
    constructor(props){
        super(props);

        this.state = {
            chartConfig: {
                title: {
                    text: this.props.fullCountryReport == true ? '' : "<h2 class='title--card'>"+this.props.title+"</h2>",
                    align: 'left'
                },
                credits: {
                    enabled: true,
					text: "",
					href: '',
					style: {
						cursor: 'arrow'
					},
					position: {
						x: -130
					}
                },
                colors: this.props.colors,
                chart: {
                    height: this.props.fullCountryReport == true ? 250 : window.innerWidth > 768 ? 450 : 770,
                    type: this.props.type,
                    backgroundColor: '#F0F0F0',
                    events: {
                        render: function() {
                            let chart = this;
                            if (!chart.customImage)
                            {
                                chart.customImage = chart.renderer.image(
                                    `${IMG_URL}osh-barometer/img/EU-OSHA-en.png`,
                                    chart.chartWidth - 130,
                                    chart.chartHeight - 37,
                                    130,
                                    37
                                ).add();
                                chart.customImage.attr({
									class:'osha-logo'
								});
                            }
                            else
                            {
                                chart.customImage.attr({
                                    x: chart.chartWidth - 130,
                                    y: chart.chartHeight - 37
                                });
                            }
                    
                            if (chart.fullscreen.isOpen) {
                                chart.customImage.css({
                                    display: 'block'
                                });
                                chart.container.className = 'highcharts-container full-screen';
                            }
                            else
                            {
                                chart.customImage.css({
                                    display: ''
                                });	
                                chart.container.className = 'highcharts-container';
                           }
                        }					
                    },
                },
				exporting: {
					enabled: this.props.fullCountryReport == true ? false : true,
					buttons: {
						contextButton: {
							menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]							
						}
					},
                    menuItemDefinitions: {
                        "downloadXLS": {
                            onclick: function() {
                                xlsxCustomExport('Trend', this.series, this.title.textStr);
                            }
                        }
                    }
				},
				navigation: {
					buttonOptions: {
						theme: {
							fill: 'transparent',
							states: {
								hover: {
									fill: '#CCC'
								},
								select: {
									fill: 'transparent'
								}
							}
						}
					}
				},
                yAxis: {
                    title: {
                        text: ''
                    }
                },
				tooltip: {},
                plotOptions: {},
                series: []
            },
            isLoading: false
        }
    }

    // Init chart config so the Chart loads correctly
    initChart = () => {
        this.setState({ chartConfig: {
            title: {
                text: this.props.fullCountryReport == true ? '' : "<h2 class='title--card'>"+ReactHtmlParser(this.props.literals["L"+this.props.chartType[0].title])+"</h2>",
                align: 'left',
                widthAdjust: -50,
                style: {
                    zIndex: 1,
                    lineHeight:36
                }
            },
            credits: {
                enabled: true,
                text: "",
                href: '',
                style: {
                    cursor: 'arrow'
                },
                position: {
                    x: -130
                }
            },
            colors: this.props.colors,
            chart: {
                height: window.innerWidth > 768 ? this.props.fullCountryReport == true ? 250 : 450 : 770,
                type: this.props.type,
                backgroundColor: '#F0F0F0',
                events: {
                    render: function() {
                          var chart = this;
                       if (!chart.customImage)
                       {
                           chart.customImage = chart.renderer.image(
                               `${IMG_URL}osh-barometer/img/EU-OSHA-en.png`,
                               chart.chartWidth - 130,
                               chart.chartHeight - 37,
                               130,
                               37
                           ).add();
                           chart.customImage.attr({
                            class:'osha-logo'
                        });
                       }
                       else
                       {
                           chart.customImage.attr({
                               x: chart.chartWidth - 130,
                               y: chart.chartHeight - 37
                           });
                       }
                
                       if (chart.fullscreen.isOpen) {
                           chart.customImage.css({
                               display: 'block'
                           });
                           chart.container.className = 'highcharts-container full-screen';
                         }
                       else
                       {
                           chart.customImage.css({
                               display: ''
                           });	
                           chart.container.className = 'highcharts-container';
                       }
                    }					
                },
            },
            exporting: {
                enabled: this.props.fullCountryReport == true ? false : true,
                buttons: {
                    contextButton: {
                        menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]							
                    }
                },
                sourceWidth: 1300,
                filename: this.props.literals[this.props.chartType[0].title] //this.props.title.replace(/ /g, '_')
            },
            navigation: {
                buttonOptions: {
                    theme: {
                        fill: 'transparent',
                        states: {
                            hover: {
                                fill: '#CCC'
                            },
                            select: {
                                fill: 'transparent'
                            }
                        }
                    }
                }
            },
            legend:{
                //reversed: this.props.legend
                verticalAlign: 'bottom',
                symbolRadius: 0,
                //layout: 'vertical',
                itemMarginTop:4,
                itemMarginBottom:4,
                //width: 300,
                itemStyle: {
                    fontFamily: 'OpenSans',
                    fontWeight: 'normal',
                    fontSize:'12px',
                    textOverflow: "ellipsis",
                    width: 250
                }
            },
            yAxis: {
                gridLineColor: '#FFF',
                gridLineWidth: 2,
                startOnTick: true,
                endOnTick: true,
                tickInterval: this.props.step ? this.props.step : null,
                max: this.props.yAxisMax ? this.props.yAxisMax : null,
                title: {
                    text: ''
                },
                labels: {
                    format: this.props.percentage === true ? '{value}%' : `{value}`,
                    style: {
                        fontFamily: 'OpenSans-bold',
                        fontWeight: 'normal',
                        fontSize:  this.props.fullCountryReport ? '10px' : '12px',
                        textOverflow: 'none'
                    }
                }
            },
            xAxis: {
                lineWidth: 0,
                labels: {	
                    style: {
                        fontFamily: 'OpenSans-bold',
                        fontWeight: 'normal',
                        fontSize: this.props.fullCountryReport ? '10px' : '12px' ,
                        textOverflow: 'none'
                    }
                }
            },
            plotOptions: {},
            series: []
        } })
    }

    // Gets data for the selected Chart
    getLoadData = (chartType) => {
        let categories = [];
        let series = [];
        let chart = null;

        this.initChart();

        chart = chartType[0];

        // Load the texts for the credits in the image when maximising or exporting the chart
        this.getCredits(chart.chart);

        let requestFilter = {
            chart: chart.chart,
            indicator: chart.chartIndicator,
            selectedCountry: this.props.selectedCountry
        }
        getNewChartData(requestFilter)
            .then((data) => {
                categories = data.resultset.xAxisCategories;
                
                try {
                    this.setState({ ...this.state, isLoading: true });
                    
                    data.resultset.data.forEach(element => {
                        series.push({name: element.name, data: element.data});
                    });
                    
                } catch (error) {
                    console.log('error fetching data', error)
                } finally {
                    this.setState({ ...this.state, isLoading: false })
                }

                
                if (this.props.type == 'line') {

                    this.setState({ 
                        chartConfig: {...this.state.chartConfig,
                            tooltip: {					
                                useHTML: true,
                                borderColor:"#529FA2",
                                style: {
                                    opacity: 1,
                                    zIndex: 100
                                },
                                formatter: function () {
                                    return '<ul class="tooltip-item">'+
                                    '<li><strong>Country: </strong> ' + this.series.name + '</li>' +
                                    '<li><strong>Year: </strong> '+ this.point.category + '</li>' +
                                    '<li><strong class="tooltip-value up">Value: </strong>' + this.point.y +'%</li>' +
                                    '</ul>';
                                }
                            },
                            plotOptions: {
                                series: {
                                    label: {
                                        connectorAllowed: false
                                    },
                                pointStart: 2010}
                            }, 
                            series
                        } 
                    })
                }  
                
                if (this.props.type == 'column' || this.props.type == 'bar') {
                    
                    this.setState({
                        chartConfig: {...this.state.chartConfig, 
                            xAxis: {
                                categories,
                                plotLines: [
                                    {
                                        color: 'black',
                                        width: 2,
                                        value: 0.5,
                                        id: 'break-eu',
                                        zIndex:1
                                    }
                                ],
                            },
                            tooltip: {					
                                useHTML: true,
                                borderColor:"#529FA2",
                                style: {
                                    opacity: 1,
                                    zIndex: 100
                                },
                                formatter: function () {
                                    return '<ul class="tooltip-item">'+
                                    '<li><strong>Trend: </strong> ' + this.series.name + '</li>' +
                                    '<li><strong>Country: </strong> '+ this.point.category + '</li>' +
                                    '<li><strong class="tooltip-value up">Value: </strong>' + this.point.y +'</li>' +
                                    '</ul>';
                                }
                            },
                            plotOptions: {
                                series: {
                                    pointPadding: 0.11,
                                    groupPadding: 0.15,
                                    borderWidth: 0,
                                    pointStart: 0
                                },
                            }, 
                            series
                        }
                    })
                }
            });

    }
    
    getCredits = (chart) => {
        getDatasourceAndDates(chart).then((res)=>{
            let text = res;
            this.setState({
                chartConfig: {...this.state.chartConfig, credits: {...this.state.chartConfig.credits, text}}
            })
        })		
    }
    
    updateDimension = () => {
        const width = window.innerWidth;
        const height = window.innerHeight;

        if (width > 767) {
            if (isFullscreen()) {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: height}
                    }
                });
            } else {
                if (this.props.fullCountryReport != true)
                {
                    this.setState({
                        chartConfig: {
                            ...this.state.chartConfig,
                            chart: {...this.state.chartConfig.chart, height: 450}
                        }
                    })
                }
            }
        }

        if (width < 768) {
            if (isFullscreen()) {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: height}
                    }
                })
            } else {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: 770}
                    }
                })
            }
        }
    }

    componentDidMount() {
        this.getLoadData(this.props.chartType);

        window.addEventListener('resize', this.updateDimension);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.type != this.props.type) {
            this.setState({ chartConfig: {...this.state.chartConfig, chart: {...this.state.chartConfig.chart, type: this.props.type} }});
        }

        if (prevProps.chartType != this.props.chartType || prevProps.countrySelected != this.props.countrySelected) {
            this.getLoadData(this.props.chartType);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimension);
    }

    render(){
        return(
            <div className='chart-container'>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={this.state.chartConfig}
                    containerProps={{ className: 'chartContainer' }}
                />
            </div>
        )
    }
}

export default SafetyRisksChart;